import { request } from '@/api/common'
import apis from '@/common/config/host'

const GET_MEMBERSHIP = apis.cApiDomain + '/user/getMembership'

export const getMembership = function (data) {
  return request.post(GET_MEMBERSHIP, data)
}
